const { loadStripe } = require('@stripe/stripe-js');

export const promise = loadStripe(
  process.env.NODE_ENV === 'production'
    ? 'pk_live_51H6jjZEbTvaw98nusm7NUfoHfeCvIUPMeHbYRQGsVOS90GQNgfir25P4s3vrkSqNJELJYBOKTB4Q9SEEL5hyTIpe001DyFiXE5'
    : 'pk_test_51H6jjZEbTvaw98nuN8gFihoLHzrriOD9VneQiD38WbGcHBDCfuKVGpuuEaT9PJNByA2mskrt6ryORTU8dNDm501V00pL1xYK8J'
);
